const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? "https://api.wekarecords.com" : "http://localhost:5001");

const SIGNIN_PATH = "/sign-in";

export const getAuthToken = () => localStorage.getItem("treasurer.authToken");

const clearAuthAndRedirectToSignin = () => {
  localStorage.removeItem("treasurer.authToken");
  localStorage.removeItem("treasurer.authUser");
  window.location.hash = "#" + SIGNIN_PATH;
};

export const apiRequest = async (path, options = {}) => {
  const token = getAuthToken();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {})
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers
  });

  if (response.status === 401) {
    clearAuthAndRedirectToSignin();
    let message = "Session expired. Please sign in again.";
    try {
      const data = await response.json();
      if (data.error) message = data.error;
    } catch (_) {
      // ignore parse errors
    }
    throw new Error(message);
  }

  if (!response.ok) {
    let message = "Request failed";
    try {
      const data = await response.json();
      message = data.error || message;
    } catch (error) {
      // ignore parse errors
    }
    throw new Error(message);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};
